export default "__VITE_ASSET__BQVdR$bk__"